<button
    cButton
    class="button"
    (click)="onClick()"
    type="button">
    <svg cIcon class="icon" [name]="icon"></svg>
    <span class="label" [translate]="label"></span>
</button>